import React from "react";

// STYLES
import styled from "styled-components";
import './social.component.css';

// ICONS
import FaFacebook from 'react-icons/lib/fa/facebook'
import FaTwitter from 'react-icons/lib/fa/twitter'
import TiSocialInstagram from 'react-icons/lib/ti/social-instagram'

export default class Social extends React.Component {
    render() {
        return(
            <SocialIcons  className={this.props.onSrollHeader ? '' : 'onScrollSocial'}>
                <a href="https://www.facebook.com/tasteportugal.ahresp/" target="_blank" rel="noopener noreferrer"><FaFacebook/></a>
                <a href="https://twitter.com/TasteAhresp" target="_blank" rel="noopener noreferrer"><FaTwitter/></a>
                <a href="https://www.instagram.com/tasteportugal.ahresp/" target="_blank" rel="noopener noreferrer"><TiSocialInstagram/></a>
            </SocialIcons>
        )
    } 
}

const SocialIcons =  styled.div `
    display: flex;
    align-items:center;
    justify-content: center;
    font-size:22px;

    a{
        color: #FFF;
        transition: all 0.3s ease;
    }

    a:nth-child(2){
        margin-left: 15px;
        margin-right: 15px;
    }

    a:hover{
        color: #11837B;
    }
`




// WEBPACK FOOTER //
// ./src/components/social/social.component.js